// ============================================================
// FIREBASE CLIENT SDK INITIALIZATION
// Single instance shared across the entire web app.
// Replace the config values with your actual Firebase project config.
// Store sensitive values in .env.local — NEVER commit them.
// ============================================================

import { initializeApp, getApps } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Prevent duplicate initialization in HMR environments
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const firebaseAuth = getAuth(app);
export const firestore = getFirestore(app);
export const firebaseStorage = getStorage(app);
export const firebaseFunctions = getFunctions(app, 'us-central1');

// Messaging is only supported in browsers that support it
export const getFirebaseMessaging = async () => {
  const supported = await isSupported();
  return supported ? getMessaging(app) : null;
};

// ─── Emulator connections (development only) ───────────────────────────────
if (import.meta.env.VITE_USE_EMULATORS === 'true') {
  connectAuthEmulator(firebaseAuth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(firestore, 'localhost', 8080);
  connectStorageEmulator(firebaseStorage, 'localhost', 9199);
  connectFunctionsEmulator(firebaseFunctions, 'localhost', 5001);
}

export default app;
